export default [
  {
    icon: 'mdi-close',
    title: 'Batal Verval',
    event: 'onBatalVerval',
    akses: 'psp-peringkat-kandidat.batal-verval',
  },
];
